import SentimentTrackerOnboardingLayoutContainer from "./SentimentTrackerOnboardingLayoutContainer";
import SentimentTrackerOnboardingLayoutStore from "./SentimentTrackerOnboardingLayoutStore";

export default SentimentTrackerOnboardingLayoutStore(SentimentTrackerOnboardingLayoutContainer);
